import { render, staticRenderFns } from "./ChosenDataReport.vue?vue&type=template&id=54183af4&scoped=true&lang=pug"
import script from "./ChosenDataReport.vue?vue&type=script&lang=js"
export * from "./ChosenDataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54183af4",
  null
  
)

export default component.exports